import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * ContextWarning Component
 * 
 * Displays a premium warning banner if the user has not selected a sub-account context.
 * This is primarily used on pages that require a sub-account to perform actions (Dashboard, Assignments, Workflows).
 * 
 * @param {string} message - The specific action-related message to display.
 */
export default function ContextWarning({ title , message }) {
  const { user } = useAuth();

  // Only show if subAccountUID is missing
  if (user?.subAccountUID) { return null; }

  return (
  <div
      className="bg-warning/10 border-warning text-base p-4 rounded-lg mb-6"
      role="alert"
    >
      <div className="flex items-start gap-3">
        <div>
          <p className="font-bold text-sm">{title}</p>
          <p className="text-sm">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
